import React from "react";
import {
    COLORS,
    MESSAGES,
    SPACING,
    SPINNER,
    TYPOGRAPHY,
} from "../constants/contentManagerAccessConstants";

/**
 * Props for LoadingState component
 * @typedef {Object} LoadingStateProps
 * @property {boolean} isAuthenticated - Flag indicating whether the user is authenticated
 */
interface LoadingStateProps {
    isAuthenticated: boolean;
}

/**
 * Component to display when the user is loading
 * @param isAuthenticated
 * @constructor
 */
export const LoadingState: React.FC<LoadingStateProps> = ({ isAuthenticated }) => {
    return (
        <div className="content-manager-access-container">
            <div className="feedback-container">
                <div className="loading-spinner">
                    <svg className="spinner-icon" viewBox={SPINNER.VIEWBOX_SIZE}>
                        <circle
                            className="spinner-path"
                            cx={SPINNER.CENTER_X}
                            cy={SPINNER.CENTER_Y}
                            r={SPINNER.RADIUS}
                            fill="none"
                            strokeWidth={SPINNER.STROKE_WIDTH}
                        />
                    </svg>
                </div>
                <h3
                    style={{
                        marginTop: SPACING.MARGIN_TOP_HEADING,
                        marginBottom: SPACING.MARGIN_BOTTOM_HEADING,
                    }}
                >
                    {isAuthenticated ? MESSAGES.SETTING_UP_SESSION : MESSAGES.LOADING_AUTH}
                </h3>
                <p
                    style={{
                        color: COLORS.TEXT_SECONDARY,
                        fontSize: TYPOGRAPHY.FONT_SIZE_BODY,
                        lineHeight: TYPOGRAPHY.LINE_HEIGHT_BODY,
                        maxWidth: SPACING.MAX_WIDTH_TEXT,
                        margin: `0 auto ${SPACING.MARGIN_BOTTOM_TEXT}`,
                    }}
                >
                    {isAuthenticated
                        ? MESSAGES.SESSION_SETUP_DESCRIPTION
                        : MESSAGES.CHECKING_AUTH_STATUS}
                </p>
            </div>
        </div>
    );
};
